import type { ReactElement } from 'react'
import { Fragment } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import DeveloperSideMenu from '../../components/Developer/SideMenu'
import { BaseLayout, ApiKeysLayout, WebhooksLayout } from '../../layouts'

const DeveloperGuidePage = (): ReactElement => (
  <Fragment>
    <Helmet>
      <title>API keys</title>
      <meta
        name="description"
        content="API keys | Getting started with Imagekit SDK (JS, ReactJS, VueJS, Android, .NET and more...)"
      />
    </Helmet>
    <ApiKeysLayout />
  </Fragment>
)

const WebhooksPage = (): ReactElement => (
  <Fragment>
    <Helmet>
      <title>Webhooks</title>
      <meta name="description" content="Webhook setup" />
    </Helmet>
    <WebhooksLayout />
  </Fragment>
)

const DeveloperRouter = (): ReactElement => {
  const { path } = useRouteMatch()

  return (
    <BaseLayout menu={<DeveloperSideMenu />}>
      <Switch>
        <Route path={`${path}`} exact>
          <Redirect to={`${path}/api-keys`} />
        </Route>
        <Route exact path={`${path}/api-keys`}>
          <DeveloperGuidePage />
        </Route>
        <Route exact path={`${path}/webhooks`}>
          <WebhooksPage />
        </Route>
      </Switch>
    </BaseLayout>
  )
}

export default DeveloperRouter
